/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ComProviderTimespan { 
    data: ComProviderTimespan.DataEnum;
    endDate?: string;
    startDate?: string;
}
export namespace ComProviderTimespan {
    export const DataEnum = {
        GroundControl: 'GROUND_CONTROL',
        MetOcean: 'MET_OCEAN',
        Globalstar: 'GLOBALSTAR',
        Orbcomm: 'ORBCOMM',
        IridiumJapan: 'IRIDIUM_JAPAN'
    } as const;
    export type DataEnum = typeof DataEnum[keyof typeof DataEnum];
}


export type DataEnum = typeof ComProviderTimespan.DataEnum[keyof typeof ComProviderTimespan.DataEnum];
